module.exports = __webpack_public_path__ + "img/food_landing_banner_opt.006cbe29.jpg";